import axios from "../axiosPlugin.js";
const BASE_URL = "/api/accountPayable";

export const accPayCreate = (data, loading = true) => {
  return axios({
    url: `${BASE_URL}/create`,
    method: "post",
    data: {
      data,
      loading,
    }
  });
};

export const extraction = (data, loading = true) => {
  return axios({
    url: `${BASE_URL}/extraction`,
    method: "get",
    data: {
      data,
      loading,
    }
  });
};

export const update = (data, loading = true) => {
  return axios({
    url: `${BASE_URL}/update`,
    method: "post",
    data: { data }
  });
};